<template>
    <div class="configurationsocialnetworksinfo">
        <br>
        <br>
        <div class="configurationagreementsinfo">
            <div class="columns">
            <div class="column">
                    <h1 class="subtitle is-2">
                        Redes sociales
                    </h1>
                </div>
                <div class="column">
                    <span class="is-pulled-right">
                        <button class="button is-primary" @click="editSocialNetworks()">
                            <b-icon icon="edit"></b-icon>
                            <span>Editar las redes sociales</span>
                        </button>
                    </span>
                </div>
            </div>
        </div>
        <div v-if="isSocialNetworksEmpty">
            <div class="columns is-centered">
                <br>
                <b-message title='Redes sociales no encontradas' has-icon type="is-warning" size="is-medium" :closable='false'>
                    No hay registros sobre las redes sociales, agregue nuevas redes sociales haciendo click <a @click="editSocialNetworks()">aquí</a>.               
                </b-message>
                <br>
            </div>
        </div>
        <div v-else>
            <br>
            <b-table
                :data="social_networks"
                :paginated=true
                per-page=10
                striped
                hoverable
                :current-page="currentPage"
                :pagination-simple=false
                pagination-position="bottom"
                default-sort-direction="asc"
                sort-icon="arrow-up"
                sort-icon-size="is-small"
                default-sort="publication.title"
                aria-next-label="Siguiente"
                aria-previous-label="Anterior"
                aria-page-label="Página"
                aria-current-label="Página actual">
                <b-table-column
                    field= 'name'
                    label= 'Nombre'
                    v-slot="props"
                >
                {{ props.row.name }}
                </b-table-column>
                <b-table-column
                    field= 'description'
                    label= 'Descripción'
                    v-slot="props"
                >
                {{ props.row.description }}
                </b-table-column>
                <b-table-column
                    field= 'link'
                    label= 'Link'
                    v-slot="props"
                >
                {{ props.row.link }}
                </b-table-column>
                <b-table-column
                    field= 'is_active'
                    label= '¿Activa?'
                    v-slot="props"
                >
                {{ isSocialNetworkActive(props.row) }}
                </b-table-column>
            </b-table>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ConfigurationSocialNetworksInfo',
    props:{
        social_networks:{
            type: Array,
            default:() => []
        }
    },
    data(){
        return {
            currentPage:1
        }
    },
    computed:{
        isSocialNetworksEmpty(){
            return Object.entries(this.social_networks).length === 0
        }  
    },
    methods:{
        editSocialNetworks(){
            window.location.href="/administrate/vime_configuration_social_network_edit/"
        },
        isSocialNetworkActive(social_network_data){
            if(social_network_data.is_active)
                return 'Sí'
            else
                return 'No'
        }
    }
}
</script>